import { BaseResponse } from 'common/types/api'
import axios from 'core/api'

import {
  CreateOrderResponse,
  CreditFeatureAccessPreview,
  CreditFeatureAccessPreviewBody,
  CreditFeatureCost,
  CreditOrdersCountData,
  CreditOrdersResponse,
  CreditPackage,
  CreditWalletProfile,
  CreditWalletTransactionsResponse,
  GetCreditOrdersParams,
  OrderPreview,
  OrderRequestBody,
  RedeemPromoBody,
  RedeemPromoResponse,
} from './types'

export const getCreditWalletProfile = () =>
  axios.get<BaseResponse<CreditWalletProfile>>('/credits/wallets/profile')

export const redeemCreditPromotion = (body: RedeemPromoBody) =>
  axios.post<BaseResponse<RedeemPromoResponse>>('/credits/promotions/redeem', body, {
    silentError: true,
  })

export const getCreditWalletTransactions = (params: {
  page: number
  pageSize: number
  transaction_type?: string
}) => axios.get<CreditWalletTransactionsResponse>('/credits/wallets/profile/transactions', { params })

export const getCreditPackages = () =>
  axios.get<BaseResponse<CreditPackage[]>>('/credits/packages/pricing', {
    params: { includePurchaseCount: false, isEnabled: true },
  })

export const previewCreditOrder = (body: OrderRequestBody) =>
  axios.post<BaseResponse<OrderPreview>>('/credits/orders/preview', body)

export const createCreditOrder = (body: OrderRequestBody) =>
  axios.post<BaseResponse<CreateOrderResponse>>('/credits/orders', body, {
    silentError: true,
  })

export const getCreditOrders = (params: GetCreditOrdersParams) =>
  axios.get<CreditOrdersResponse>('/credits/orders/profile', { params })

export const getCreditOrdersCount = () =>
  axios.get<BaseResponse<CreditOrdersCountData>>('/credits/orders/profile/count')

export const getCreditFeatureCost = (featureCode: string) =>
  axios.get<BaseResponse<CreditFeatureCost>>(`/credits/features/cost/${featureCode}`)

export const previewCreditFeatureAccess = (body: CreditFeatureAccessPreviewBody) =>
  axios.post<BaseResponse<CreditFeatureAccessPreview>>('/credits/features/access/preview', body)
